/* GENERATED by /app/scripts/build_nerve_assets.py — DO NOT EDIT BY HAND.
   Nerve Center v4 art-to-metadata (spec §24-26, §69-71): normalized
   coordinates, per-slot guide splines + per-fiber sprite masks. */
export const NERVE_ASSET_BASE = "/hero/nerve/v4";

export type NerveSlot = {
  x: number; y: number; r: number; labelSide: "below" | "above" | "left" | "right";
  departure: number[]; arrival: number[]; tEnd: number; guide: number[][];
  fiber: { src: string; bbox: number[]; width: number };
};
export type NerveTopologyCfg = { id: string; plate: string; count: number; slots: NerveSlot[] };
export type NerveEnvCfg = { src: string; w: number; h: number;
  nucleus: { x: number; y: number; ri: number; rm: number; ro: number } };

export const NERVE_ENV: Record<string, NerveEnvCfg> = {
 "desktop": {
  "src": "nerve_environment_desktop_v4.jpg",
  "w": 1264,
  "h": 848,
  "nucleus": {
   "x": 0.4768,
   "y": 0.4593,
   "ri": 0.0831,
   "rm": 0.1344,
   "ro": 0.1747
  }
 },
 "mobile": {
  "src": "nerve_environment_mobile_v4.jpg",
  "w": 848,
  "h": 1264,
  "nucleus": {
   "x": 0.5057,
   "y": 0.4254,
   "ri": 0.1568,
   "rm": 0.2376,
   "ro": 0.3088
  }
 }
};

export const NERVE_TOPOLOGIES: Record<string, Record<number, NerveTopologyCfg>> = {
 "desktop": {
  "3": {
   "id": "desktop_3",
   "plate": "nerve_topology_desktop_3_v1.webp",
   "count": 3,
   "slots": [
    {
     "x": 0.8452,
     "y": 0.1848,
     "r": 0.0502,
     "labelSide": "below",
     "departure": [
      0.6136,
      0.4463
     ],
     "arrival": [
      0.804,
      0.217
     ],
     "tEnd": 0.831,
     "guide": [
      [
       0.6136,
       0.4463
      ],
      [
       0.6725,
       0.3255
      ],
      [
       0.7661,
       0.2442
      ],
      [
       0.8452,
       0.1848
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_3_s0_v1.webp",
      "bbox": [
       0.5934,
       0.0649,
       0.3291,
       0.4705
      ],
      "width": 0.0955
     }
    },
    {
     "x": 0.4932,
     "y": 0.8876,
     "r": 0.0502,
     "labelSide": "above",
     "departure": [
      0.5373,
      0.6426
     ],
     "arrival": [
      0.4965,
      0.8178
     ],
     "tEnd": 0.715,
     "guide": [
      [
       0.5373,
       0.6426
      ],
      [
       0.4734,
       0.7037
      ],
      [
       0.5064,
       0.8141
      ],
      [
       0.4932,
       0.8876
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_3_s1_v1.webp",
      "bbox": [
       0.4146,
       0.5932,
       0.1717,
       0.3962
      ],
      "width": 0.1064
     }
    },
    {
     "x": 0.1182,
     "y": 0.1624,
     "r": 0.0502,
     "labelSide": "below",
     "departure": [
      0.3642,
      0.3427
     ],
     "arrival": [
      0.1583,
      0.1993
     ],
     "tEnd": 0.817,
     "guide": [
      [
       0.3642,
       0.3427
      ],
      [
       0.2588,
       0.3566
      ],
      [
       0.192,
       0.2165
      ],
      [
       0.1182,
       0.1624
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_3_s2_v1.webp",
      "bbox": [
       0.0498,
       0.0601,
       0.3521,
       0.3667
      ],
      "width": 0.0971
     }
    }
   ]
  },
  "4": {
   "id": "desktop_4",
   "plate": "nerve_topology_desktop_4_v1.webp",
   "count": 4,
   "slots": [
    {
     "x": 0.8921,
     "y": 0.1266,
     "r": 0.0436,
     "labelSide": "left",
     "departure": [
      0.6133,
      0.4403
     ],
     "arrival": [
      0.8656,
      0.1716
     ],
     "tEnd": 0.878,
     "guide": [
      [
       0.6133,
       0.4403
      ],
      [
       0.6632,
       0.2536
      ],
      [
       0.8316,
       0.2664
      ],
      [
       0.8921,
       0.1266
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_4_s0_v1.webp",
      "bbox": [
       0.5823,
       0.0307,
       0.3718,
       0.4811
      ],
      "width": 0.0761
     }
    },
    {
     "x": 0.889,
     "y": 0.8577,
     "r": 0.0436,
     "labelSide": "left",
     "departure": [
      0.5918,
      0.5704
     ],
     "arrival": [
      0.8479,
      0.8488
     ],
     "tEnd": 0.885,
     "guide": [
      [
       0.5918,
       0.5704
      ],
      [
       0.7477,
       0.5323
      ],
      [
       0.7574,
       0.869
      ],
      [
       0.889,
       0.8577
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_4_s1_v1.webp",
      "bbox": [
       0.5491,
       0.4976,
       0.3956,
       0.4575
      ],
      "width": 0.0782
     }
    },
    {
     "x": 0.0947,
     "y": 0.8577,
     "r": 0.0433,
     "labelSide": "right",
     "departure": [
      0.3927,
      0.6206
     ],
     "arrival": [
      0.1175,
      0.8076
     ],
     "tEnd": 0.885,
     "guide": [
      [
       0.3927,
       0.6206
      ],
      [
       0.3103,
       0.7433
      ],
      [
       0.1491,
       0.6888
      ],
      [
       0.0947,
       0.8577
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_4_s2_v1.webp",
      "bbox": [
       0.0301,
       0.5542,
       0.4122,
       0.3903
      ],
      "width": 0.0816
     }
    },
    {
     "x": 0.0891,
     "y": 0.1266,
     "r": 0.0436,
     "labelSide": "right",
     "departure": [
      0.3655,
      0.3402
     ],
     "arrival": [
      0.1262,
      0.153
     ],
     "tEnd": 0.858,
     "guide": [
      [
       0.3655,
       0.3402
      ],
      [
       0.2384,
       0.3726
      ],
      [
       0.1799,
       0.168
      ],
      [
       0.0891,
       0.1266
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_4_s3_v1.webp",
      "bbox": [
       0.0316,
       0.0389,
       0.3805,
       0.3939
      ],
      "width": 0.0771
     }
    }
   ]
  },
  "5": {
   "id": "desktop_5",
   "plate": "nerve_topology_desktop_5_v1.webp",
   "count": 5,
   "slots": [
    {
     "x": 0.6184,
     "y": 0.0963,
     "r": 0.039,
     "labelSide": "below",
     "departure": [
      0.4942,
      0.2566
     ],
     "arrival": [
      0.5824,
      0.1056
     ],
     "tEnd": 0.797,
     "guide": [
      [
       0.4942,
       0.2566
      ],
      [
       0.5029,
       0.1481
      ],
      [
       0.5575,
       0.1036
      ],
      [
       0.6184,
       0.0963
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_5_s0_v1.webp",
      "bbox": [
       0.4367,
       0.0189,
       0.2326,
       0.2771
      ],
      "width": 0.073
     }
    },
    {
     "x": 0.8876,
     "y": 0.467,
     "r": 0.039,
     "labelSide": "left",
     "departure": [
      0.6139,
      0.4619
     ],
     "arrival": [
      0.8513,
      0.4811
     ],
     "tEnd": 0.858,
     "guide": [
      [
       0.6139,
       0.4619
      ],
      [
       0.7052,
       0.3412
      ],
      [
       0.8049,
       0.5328
      ],
      [
       0.8876,
       0.467
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_5_s1_v1.webp",
      "bbox": [
       0.5989,
       0.3561,
       0.341,
       0.1958
      ],
      "width": 0.0642
     }
    },
    {
     "x": 0.8256,
     "y": 0.8119,
     "r": 0.039,
     "labelSide": "above",
     "departure": [
      0.5513,
      0.6307
     ],
     "arrival": [
      0.7906,
      0.791
     ],
     "tEnd": 0.864,
     "guide": [
      [
       0.5513,
       0.6307
      ],
      [
       0.6297,
       0.7314
      ],
      [
       0.7433,
       0.7575
      ],
      [
       0.8256,
       0.8119
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_5_s2_v1.webp",
      "bbox": [
       0.5008,
       0.5696,
       0.3766,
       0.3196
      ],
      "width": 0.0642
     }
    },
    {
     "x": 0.1203,
     "y": 0.813,
     "r": 0.0385,
     "labelSide": "above",
     "departure": [
      0.3422,
      0.4973
     ],
     "arrival": [
      0.1437,
      0.7707
     ],
     "tEnd": 0.871,
     "guide": [
      [
       0.3422,
       0.4973
      ],
      [
       0.2795,
       0.618
      ],
      [
       0.1752,
       0.7001
      ],
      [
       0.1203,
       0.813
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_5_s3_v1.webp",
      "bbox": [
       0.068,
       0.4328,
       0.3046,
       0.4599
      ],
      "width": 0.0639
     }
    },
    {
     "x": 0.1565,
     "y": 0.1684,
     "r": 0.0385,
     "labelSide": "below",
     "departure": [
      0.3532,
      0.3709
     ],
     "arrival": [
      0.19,
      0.1871
     ],
     "tEnd": 0.844,
     "guide": [
      [
       0.3532,
       0.3709
      ],
      [
       0.2476,
       0.3921
      ],
      [
       0.238,
       0.1808
      ],
      [
       0.1565,
       0.1684
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_5_s4_v1.webp",
      "bbox": [
       0.1036,
       0.092,
       0.2864,
       0.3502
      ],
      "width": 0.0687
     }
    }
   ]
  },
  "6": {
   "id": "desktop_6",
   "plate": "nerve_topology_desktop_6_v1.webp",
   "count": 6,
   "slots": [
    {
     "x": 0.4877,
     "y": 0.1043,
     "r": 0.0333,
     "labelSide": "below",
     "departure": [
      0.4694,
      0.2553
     ],
     "arrival": [
      0.4968,
      0.1479
     ],
     "tEnd": 0.722,
     "guide": [
      [
       0.4694,
       0.2553
      ],
      [
       0.5007,
       0.2123
      ],
      [
       0.5044,
       0.1556
      ],
      [
       0.4877,
       0.1043
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_6_s0_v1.webp",
      "bbox": [
       0.4193,
       0.0366,
       0.1258,
       0.2488
      ],
      "width": 0.0673
     }
    },
    {
     "x": 0.8459,
     "y": 0.1626,
     "r": 0.0333,
     "labelSide": "below",
     "departure": [
      0.6113,
      0.4198
     ],
     "arrival": [
      0.8207,
      0.1893
     ],
     "tEnd": 0.885,
     "guide": [
      [
       0.6113,
       0.4198
      ],
      [
       0.6801,
       0.3174
      ],
      [
       0.7756,
       0.2397
      ],
      [
       0.8459,
       0.1626
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_6_s1_v1.webp",
      "bbox": [
       0.5823,
       0.0849,
       0.3109,
       0.3797
      ],
      "width": 0.0598
     }
    },
    {
     "x": 0.8554,
     "y": 0.8067,
     "r": 0.0347,
     "labelSide": "above",
     "departure": [
      0.6096,
      0.5102
     ],
     "arrival": [
      0.8346,
      0.7701
     ],
     "tEnd": 0.892,
     "guide": [
      [
       0.6096,
       0.5102
      ],
      [
       0.631,
       0.7179
      ],
      [
       0.8035,
       0.6774
      ],
      [
       0.8554,
       0.8067
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_6_s2_v1.webp",
      "bbox": [
       0.5759,
       0.5012,
       0.3252,
       0.3844
      ],
      "width": 0.059
     }
    },
    {
     "x": 0.4877,
     "y": 0.8552,
     "r": 0.0347,
     "labelSide": "above",
     "departure": [
      0.4687,
      0.6632
     ],
     "arrival": [
      0.4759,
      0.81
     ],
     "tEnd": 0.742,
     "guide": [
      [
       0.4687,
       0.6632
      ],
      [
       0.4878,
       0.7238
      ],
      [
       0.4607,
       0.8023
      ],
      [
       0.4877,
       0.8552
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_6_s3_v1.webp",
      "bbox": [
       0.413,
       0.6285,
       0.1226,
       0.296
      ],
      "width": 0.0673
     }
    },
    {
     "x": 0.1207,
     "y": 0.8067,
     "r": 0.0333,
     "labelSide": "above",
     "departure": [
      0.3552,
      0.5535
     ],
     "arrival": [
      0.1514,
      0.801
     ],
     "tEnd": 0.898,
     "guide": [
      [
       0.3552,
       0.5535
      ],
      [
       0.2608,
       0.6021
      ],
      [
       0.2284,
       0.8076
      ],
      [
       0.1207,
       0.8067
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_6_s4_v1.webp",
      "bbox": [
       0.0728,
       0.4764,
       0.3212,
       0.4009
      ],
      "width": 0.06
     }
    },
    {
     "x": 0.1301,
     "y": 0.1615,
     "r": 0.0333,
     "labelSide": "below",
     "departure": [
      0.3655,
      0.3401
     ],
     "arrival": [
      0.1562,
      0.1885
     ],
     "tEnd": 0.871,
     "guide": [
      [
       0.3655,
       0.3401
      ],
      [
       0.2878,
       0.2812
      ],
      [
       0.1941,
       0.2344
      ],
      [
       0.1301,
       0.1615
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_6_s5_v1.webp",
      "bbox": [
       0.0839,
       0.0932,
       0.3157,
       0.3314
      ],
      "width": 0.06
     }
    }
   ]
  },
  "7": {
   "id": "desktop_7",
   "plate": "nerve_topology_desktop_7_v1.webp",
   "count": 7,
   "slots": [
    {
     "x": 0.6045,
     "y": 0.0975,
     "r": 0.0312,
     "labelSide": "below",
     "departure": [
      0.5524,
      0.2889
     ],
     "arrival": [
      0.6061,
      0.141
     ],
     "tEnd": 0.797,
     "guide": [
      [
       0.5524,
       0.2889
      ],
      [
       0.576,
       0.2296
      ],
      [
       0.6171,
       0.172
      ],
      [
       0.6045,
       0.0975
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_7_s0_v1.webp",
      "bbox": [
       0.4976,
       0.0318,
       0.1559,
       0.3137
      ],
      "width": 0.0651
     }
    },
    {
     "x": 0.8949,
     "y": 0.3428,
     "r": 0.0312,
     "labelSide": "left",
     "departure": [
      0.6134,
      0.442
     ],
     "arrival": [
      0.8653,
      0.3315
     ],
     "tEnd": 0.898,
     "guide": [
      [
       0.6134,
       0.442
      ],
      [
       0.6863,
       0.2834
      ],
      [
       0.7994,
       0.3033
      ],
      [
       0.8949,
       0.3428
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_7_s1_v1.webp",
      "bbox": [
       0.5823,
       0.2406,
       0.3576,
       0.2665
      ],
      "width": 0.0608
     }
    },
    {
     "x": 0.9067,
     "y": 0.7261,
     "r": 0.0312,
     "labelSide": "left",
     "departure": [
      0.5975,
      0.5562
     ],
     "arrival": [
      0.8767,
      0.7236
     ],
     "tEnd": 0.905,
     "guide": [
      [
       0.5975,
       0.5562
      ],
      [
       0.6938,
       0.6353
      ],
      [
       0.8014,
       0.7258
      ],
      [
       0.9067,
       0.7261
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_7_s2_v1.webp",
      "bbox": [
       0.5609,
       0.4929,
       0.3916,
       0.3054
      ],
      "width": 0.0574
     }
    },
    {
     "x": 0.4953,
     "y": 0.9041,
     "r": 0.0312,
     "labelSide": "above",
     "departure": [
      0.5123,
      0.6566
     ],
     "arrival": [
      0.4869,
      0.8617
     ],
     "tEnd": 0.824,
     "guide": [
      [
       0.5123,
       0.6566
      ],
      [
       0.5316,
       0.7421
      ],
      [
       0.4639,
       0.8243
      ],
      [
       0.4953,
       0.9041
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_7_s3_v1.webp",
      "bbox": [
       0.447,
       0.6108,
       0.1266,
       0.3667
      ],
      "width": 0.0631
     }
    },
    {
     "x": 0.1694,
     "y": 0.8664,
     "r": 0.0312,
     "labelSide": "above",
     "departure": [
      0.3658,
      0.579
     ],
     "arrival": [
      0.1978,
      0.8585
     ],
     "tEnd": 0.905,
     "guide": [
      [
       0.3658,
       0.579
      ],
      [
       0.3588,
       0.7617
      ],
      [
       0.2707,
       0.8446
      ],
      [
       0.1694,
       0.8664
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_7_s4_v1.webp",
      "bbox": [
       0.1195,
       0.5377,
       0.2951,
       0.4033
      ],
      "width": 0.0661
     }
    },
    {
     "x": 0.0602,
     "y": 0.4878,
     "r": 0.0312,
     "labelSide": "right",
     "departure": [
      0.3399,
      0.4687
     ],
     "arrival": [
      0.0886,
      0.4991
     ],
     "tEnd": 0.892,
     "guide": [
      [
       0.3399,
       0.4687
      ],
      [
       0.2489,
       0.5167
      ],
      [
       0.1455,
       0.528
      ],
      [
       0.0602,
       0.4878
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_7_s5_v1.webp",
      "bbox": [
       0.0119,
       0.4092,
       0.3457,
       0.1804
      ],
      "width": 0.0584
     }
    },
    {
     "x": 0.2208,
     "y": 0.1341,
     "r": 0.0312,
     "labelSide": "below",
     "departure": [
      0.3509,
      0.3786
     ],
     "arrival": [
      0.2469,
      0.1532
     ],
     "tEnd": 0.864,
     "guide": [
      [
       0.3509,
       0.3786
      ],
      [
       0.2834,
       0.327
      ],
      [
       0.2959,
       0.1648
      ],
      [
       0.2208,
       0.1341
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_7_s6_v1.webp",
      "bbox": [
       0.1741,
       0.0672,
       0.2104,
       0.3656
      ],
      "width": 0.0615
     }
    }
   ]
  },
  "8": {
   "id": "desktop_8",
   "plate": "nerve_topology_desktop_8_v1.webp",
   "count": 8,
   "slots": [
    {
     "x": 0.4903,
     "y": 0.075,
     "r": 0.0297,
     "labelSide": "below",
     "departure": [
      0.4703,
      0.2552
     ],
     "arrival": [
      0.4954,
      0.1153
     ],
     "tEnd": 0.776,
     "guide": [
      [
       0.4703,
       0.2552
      ],
      [
       0.4648,
       0.1928
      ],
      [
       0.5109,
       0.1357
      ],
      [
       0.4903,
       0.075
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_8_s0_v1.webp",
      "bbox": [
       0.4106,
       0.0071,
       0.1392,
       0.2866
      ],
      "width": 0.0665
     }
    },
    {
     "x": 0.8123,
     "y": 0.1458,
     "r": 0.0297,
     "labelSide": "below",
     "departure": [
      0.6093,
      0.4067
     ],
     "arrival": [
      0.794,
      0.1794
     ],
     "tEnd": 0.885,
     "guide": [
      [
       0.6093,
       0.4067
      ],
      [
       0.6237,
       0.2299
      ],
      [
       0.7706,
       0.2574
      ],
      [
       0.8123,
       0.1458
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_8_s1_v1.webp",
      "bbox": [
       0.5728,
       0.0778,
       0.2856,
       0.3479
      ],
      "width": 0.0551
     }
    },
    {
     "x": 0.9167,
     "y": 0.489,
     "r": 0.0297,
     "labelSide": "left",
     "departure": [
      0.6137,
      0.4481
     ],
     "arrival": [
      0.8886,
      0.4815
     ],
     "tEnd": 0.898,
     "guide": [
      [
       0.6137,
       0.4481
      ],
      [
       0.7082,
       0.5519
      ],
      [
       0.8273,
       0.4519
      ],
      [
       0.9167,
       0.489
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_8_s2_v1.webp",
      "bbox": [
       0.5989,
       0.4057,
       0.3631,
       0.1639
      ],
      "width": 0.0554
     }
    },
    {
     "x": 0.8431,
     "y": 0.8309,
     "r": 0.0297,
     "labelSide": "above",
     "departure": [
      0.5901,
      0.5742
     ],
     "arrival": [
      0.8177,
      0.8159
     ],
     "tEnd": 0.905,
     "guide": [
      [
       0.5901,
       0.5742
      ],
      [
       0.7167,
       0.5647
      ],
      [
       0.7483,
       0.7954
      ],
      [
       0.8431,
       0.8309
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_8_s3_v1.webp",
      "bbox": [
       0.5498,
       0.513,
       0.3402,
       0.3986
      ],
      "width": 0.0559
     }
    },
    {
     "x": 0.4871,
     "y": 0.9111,
     "r": 0.0297,
     "labelSide": "above",
     "departure": [
      0.4951,
      0.6617
     ],
     "arrival": [
      0.4785,
      0.871
     ],
     "tEnd": 0.831,
     "guide": [
      [
       0.4951,
       0.6617
      ],
      [
       0.5343,
       0.747
      ],
      [
       0.4527,
       0.8337
      ],
      [
       0.4871,
       0.9111
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_8_s4_v1.webp",
      "bbox": [
       0.4407,
       0.638,
       0.1179,
       0.3396
      ],
      "width": 0.0618
     }
    },
    {
     "x": 0.1564,
     "y": 0.8309,
     "r": 0.0297,
     "labelSide": "above",
     "departure": [
      0.3541,
      0.5502
     ],
     "arrival": [
      0.1753,
      0.8015
     ],
     "tEnd": 0.892,
     "guide": [
      [
       0.3541,
       0.5502
      ],
      [
       0.3454,
       0.7312
      ],
      [
       0.2054,
       0.7305
      ],
      [
       0.1564,
       0.8309
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_8_s5_v1.webp",
      "bbox": [
       0.1123,
       0.5142,
       0.2888,
       0.3844
      ],
      "width": 0.0598
     }
    },
    {
     "x": 0.0615,
     "y": 0.489,
     "r": 0.0297,
     "labelSide": "right",
     "departure": [
      0.3413,
      0.4894
     ],
     "arrival": [
      0.0894,
      0.4831
     ],
     "tEnd": 0.892,
     "guide": [
      [
       0.3413,
       0.4894
      ],
      [
       0.2489,
       0.4892
      ],
      [
       0.1454,
       0.4661
      ],
      [
       0.0615,
       0.489
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_8_s6_v1.webp",
      "bbox": [
       0.0119,
       0.3939,
       0.3449,
       0.1627
      ],
      "width": 0.0574
     }
    },
    {
     "x": 0.1873,
     "y": 0.1458,
     "r": 0.0297,
     "labelSide": "below",
     "departure": [
      0.3471,
      0.3934
     ],
     "arrival": [
      0.2117,
      0.1676
     ],
     "tEnd": 0.871,
     "guide": [
      [
       0.3471,
       0.3934
      ],
      [
       0.2943,
       0.3117
      ],
      [
       0.2535,
       0.1939
      ],
      [
       0.1873,
       0.1458
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_desktop_8_s7_v1.webp",
      "bbox": [
       0.1377,
       0.0767,
       0.2445,
       0.3656
      ],
      "width": 0.0598
     }
    }
   ]
  }
 },
 "mobile": {
  "2": {
   "id": "mobile_2",
   "plate": "nerve_topology_mobile_2_v1.webp",
   "count": 2,
   "slots": [
    {
     "x": 0.2325,
     "y": 0.1657,
     "r": 0.0457,
     "labelSide": "below",
     "departure": [
      0.4541,
      0.2665
     ],
     "arrival": [
      0.2745,
      0.1725
     ],
     "tEnd": 0.837,
     "guide": [
      [
       0.4541,
       0.2665
      ],
      [
       0.381,
       0.2333
      ],
      [
       0.3238,
       0.1714
      ],
      [
       0.2325,
       0.1657
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_2_s0_v1.webp",
      "bbox": [
       0.1592,
       0.1179,
       0.3573,
       0.1788
      ],
      "width": 0.0953
     }
    },
    {
     "x": 0.6741,
     "y": 0.7023,
     "r": 0.0554,
     "labelSide": "below",
     "departure": [
      0.5508,
      0.5851
     ],
     "arrival": [
      0.6351,
      0.6791
     ],
     "tEnd": 0.749,
     "guide": [
      [
       0.5508,
       0.5851
      ],
      [
       0.6089,
       0.6155
      ],
      [
       0.6082,
       0.6808
      ],
      [
       0.6741,
       0.7023
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_2_s1_v1.webp",
      "bbox": [
       0.4894,
       0.5562,
       0.2783,
       0.2089
      ],
      "width": 0.1301
     }
    }
   ]
  },
  "3": {
   "id": "mobile_3",
   "plate": "nerve_topology_mobile_3_v1.webp",
   "count": 3,
   "slots": [
    {
     "x": 0.1331,
     "y": 0.1095,
     "r": 0.0631,
     "labelSide": "below",
     "departure": [
      0.2932,
      0.3473
     ],
     "arrival": [
      0.1704,
      0.1398
     ],
     "tEnd": 0.844,
     "guide": [
      [
       0.2932,
       0.3473
      ],
      [
       0.2581,
       0.2634
      ],
      [
       0.2201,
       0.169
      ],
      [
       0.1331,
       0.1095
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_3_s0_v1.webp",
      "bbox": [
       0.0283,
       0.0443,
       0.3219,
       0.3331
      ],
      "width": 0.1316
     }
    },
    {
     "x": 0.8725,
     "y": 0.1103,
     "r": 0.0728,
     "labelSide": "below",
     "departure": [
      0.6898,
      0.3197
     ],
     "arrival": [
      0.8272,
      0.1443
     ],
     "tEnd": 0.803,
     "guide": [
      [
       0.6898,
       0.3197
      ],
      [
       0.7657,
       0.2567
      ],
      [
       0.7833,
       0.1597
      ],
      [
       0.8725,
       0.1103
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_3_s1_v1.webp",
      "bbox": [
       0.6321,
       0.038,
       0.3573,
       0.3212
      ],
      "width": 0.1306
     }
    },
    {
     "x": 0.4986,
     "y": 0.9284,
     "r": 0.0728,
     "labelSide": "above",
     "departure": [
      0.4792,
      0.587
     ],
     "arrival": [
      0.5001,
      0.8832
     ],
     "tEnd": 0.858,
     "guide": [
      [
       0.4792,
       0.587
      ],
      [
       0.562,
       0.6977
      ],
      [
       0.4928,
       0.826
      ],
      [
       0.4986,
       0.9284
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_3_s2_v1.webp",
      "bbox": [
       0.3833,
       0.5593,
       0.2252,
       0.4407
      ],
      "width": 0.1232
     }
    }
   ]
  },
  "4": {
   "id": "mobile_4",
   "plate": "nerve_topology_mobile_4_v1.webp",
   "count": 4,
   "slots": [
    {
     "x": 0.1495,
     "y": 0.0959,
     "r": 0.0794,
     "labelSide": "below",
     "departure": [
      0.3273,
      0.3154
     ],
     "arrival": [
      0.1955,
      0.1353
     ],
     "tEnd": 0.79,
     "guide": [
      [
       0.3273,
       0.3154
      ],
      [
       0.1705,
       0.2787
      ],
      [
       0.2568,
       0.1421
      ],
      [
       0.1495,
       0.0959
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_4_s0_v1.webp",
      "bbox": [
       0.0271,
       0.0277,
       0.3608,
       0.3259
      ],
      "width": 0.136
     }
    },
    {
     "x": 0.8896,
     "y": 0.0951,
     "r": 0.0832,
     "labelSide": "left",
     "departure": [
      0.6349,
      0.2878
     ],
     "arrival": [
      0.8286,
      0.1268
     ],
     "tEnd": 0.79,
     "guide": [
      [
       0.6349,
       0.2878
      ],
      [
       0.6758,
       0.1986
      ],
      [
       0.7974,
       0.1435
      ],
      [
       0.8896,
       0.0951
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_4_s1_v1.webp",
      "bbox": [
       0.5767,
       0.0103,
       0.4222,
       0.3109
      ],
      "width": 0.1339
     }
    },
    {
     "x": 0.8687,
     "y": 0.935,
     "r": 0.0853,
     "labelSide": "above",
     "departure": [
      0.5878,
      0.5783
     ],
     "arrival": [
      0.8366,
      0.8861
     ],
     "tEnd": 0.858,
     "guide": [
      [
       0.5878,
       0.5783
      ],
      [
       0.6008,
       0.7243
      ],
      [
       0.8137,
       0.8176
      ],
      [
       0.8687,
       0.935
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_4_s2_v1.webp",
      "bbox": [
       0.5259,
       0.5451,
       0.4741,
       0.4549
      ],
      "width": 0.1453
     }
    },
    {
     "x": 0.1703,
     "y": 0.935,
     "r": 0.0853,
     "labelSide": "above",
     "departure": [
      0.3292,
      0.5368
     ],
     "arrival": [
      0.225,
      0.894
     ],
     "tEnd": 0.871,
     "guide": [
      [
       0.3292,
       0.5368
      ],
      [
       0.2174,
       0.6575
      ],
      [
       0.3486,
       0.839
      ],
      [
       0.1703,
       0.935
      ]
     ],
     "fiber": {
      "src": "fibers/nerve_fiber_mobile_4_s3_v1.webp",
      "bbox": [
       0.0425,
       0.496,
       0.3467,
       0.504
      ],
      "width": 0.1445
     }
    }
   ]
  }
 }
};
